import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = ({ color = "primary" }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress color={color} />
    </div>
  );
};

Loader.propTypes = {
  color: PropTypes.string,
};

export default Loader;
